import axios from 'axios';
import { HttpRequest } from 'Api/request.utils';
// import { baseUrlApis/*, loginApis*/ } from './index';
import { /*URL_CWS_API,*/ NOTIFICATION_PARAMS } from './constants';
import { verifyAndGetData, verifyAndGetValue, verifyAndGetToken } from './verify.utils';
import { blobToBase64, isPhantomOnline } from '@/utils/utils';
import { createURLString } from '@/utils/url'
import { store } from 'Store/store.index';
import { toJS } from 'mobx';
import qs from 'qs';
// import { COLLABORATION_CPDF_FINISH, COLLABORATION_CPDF_START } from '@/constants/app.constant';
import * as APP_CONSTANTS from 'Constants/app.constant';

// TODO FOXIT 发起协同：云编辑使用的接口
// import { shareReview } from '@/api/fwCollaboration/collaboration';

export default class CollaborationApi extends HttpRequest {
  constructor() {
    super();
    this.CPDFURI = '';
    this.currentFileBlob = null;
    this.token =  null;
    this.fileController
    this.initialize();
    this.uploadShareReviewToken = null;
  }
  initialize = () => {
    try {
      import("@/components/viewer/Controllers/index").then(controller => {
        this.fileController = controller.fileController;
      });
      let axiosClient = axios.create({
        baseURL: "https://share.foxitcloud.cn",
      });
      super.initialize(axiosClient, () => {
        this.interceptorsFn();
      });
      // baseUrlApis.getBaseUrlBy(URL_CWS_API).then((data) => {
      //   this.CPDFURI = data;
      //   let axiosClient = axios.create({
      //     baseURL: this.CPDFURI,
      //   });
      //   super.initialize(axiosClient, () => {
      //     this.interceptorsFn();
      //   });
      // });
    } catch (error) {
      throw error;
    }
  };
  setToken(value) {
    this.token = value;
  }
  releaseCurrentFileBlob() {
    this.currentFileBlob = null;
  }
  // TODO FOXIT 发起协同 用户信息 替换成云编辑信息 store.userNewStore.userToken
  getUserToken() {
    // TODO FOXIT 需要替换成云编辑信息
    if (!store.userNewStore.userToken) {
      throw 'user not login'
    }
    const result = {
      ret: 0,
      data: {
        token: store.userNewStore.userToken,
        cUserID: store.userNewStore.userData.userId,
        userEmail: store.userNewStore.userData.userId
      }
    }
    // 云编辑不一定存在用户email，后面的信息可能email需要传id
    return result;
  }
  async removeCDocId() {
    const { cwsApiUrl } = store.appStore.phantomOnlineGlobalConfig && store.appStore.phantomOnlineGlobalConfig;

    await this.fileController.removeCDocId(cwsApiUrl).catch((error) => {
      throw error;
    });
  }
  async getCDocInfo(cDocID) {
    let docName = await this.fileController.getFileName().catch((error) => {
      throw error
    })
    // TODO FOXIT 不在转换为cpdf做协同操作，因此不在判断是否cpdf，直接发起请求启动协同
    // let isCPDF = await this.fileController.isCPDFForCurrentDoc().catch((error) => {
    //   throw error
    // })
    // if (isCPDF) {
    //   let cDocID = await this.fileController.getCDocID()
    //   return {
    //     ret: 0,
    //     data: {
    //       cDocID,
    //       docName,
    //     },
    //   }
    // } else {
      // TODO FOXIT 不在转换为cpdf做协同操作，不在使用cdocId，直接使用文档docId作为参数，参数名不变
      await this.fileController.convertToCPDF(cDocID).catch((error) => {
        throw error;
      });

      // const { oldCpdfServerUrl } = store.appStore.phantomOnlineGlobalConfig && store.appStore.phantomOnlineGlobalConfig;

      // store.appStore.sendPerformanceInfo({event: COLLABORATION_CPDF_START, isEmit: false, lastEvent: true});
      // await this.fileController.convertToCPDF(oldCpdfServerUrl).catch((error) => {
      //   throw error;
      // });
      // store.appStore.sendPerformanceInfo({event: COLLABORATION_CPDF_FINISH, isEmit: true, lastEvent: true});

      // let doc = await pdfui.getCurrentPDFDoc().catch((error) => {
      //   throw error;
      // });
      // let cDocID = await doc.getDocURI().catch((error) => {
      //   throw error
      // })

      return {
        ret: 0,
        data: {
          cDocID: cDocID.cDocID,
          docName,
        },
      };
    // }
  }
  // async getCDocInfo() {
  //   let docName = await this.fileController.getFileName().catch((error) => {
  //     throw error
  //   })
  //   let isCPDF = await this.fileController.isCPDFForCurrentDoc().catch((error) => {
  //     throw error
  //   })
  //   if (isCPDF) {
  //     let cDocID = await this.fileController.getCDocID()
  //     return {
  //       ret: 0,
  //       data: {
  //         cDocID,
  //         docName,
  //       },
  //     }
  //   } else {
      // 原online: oldCpdfServerUrl = cws-az.connectedpdf.com
      // TODO FOXIT 
      // const { oldCpdfServerUrl } = store.appStore.phantomOnlineGlobalConfig && store.appStore.phantomOnlineGlobalConfig;
  //     await this.fileController.convertToCPDF(fwCpdfServerUrl).catch((error) => {
  //       throw error;
  //     });

  //     let doc = await pdfui.getCurrentPDFDoc().catch((error) => {
  //       throw error;
  //     });
  //     let cDocID = await doc.getDocURI().catch((error) => {
  //       throw error
  //     })

  //     return {
  //       ret: 0,
  //       data: {
  //         cDocID,
  //         docName,
  //       },
  //     };
  //   }
  // }
  async getFileStream(data) {
    let fileBlob = null;
    const { file, offset, blockSize } = data;
    const isPhantom = !isPhantomOnline()

    store.appStore.openFileDlg.doChangeLoadingState(true);

    fileBlob = await this.getFileBlob({ file });

    if (!fileBlob) {
      resolve({ ret: 1 });
      return;
    }

    // slice buffer
    let fileSize = fileBlob.size;
    let isEnd = offset + blockSize >= fileSize;
    let end = isEnd ? fileSize : offset + blockSize;
    const bufferBlob = fileBlob.slice(offset, end, fileBlob.type);
    let dataSize = bufferBlob.size;

    // clean doc cache
    if (isEnd) {
      // delete this.docMap[file.id];
      store.appStore.doUpdateDocModified(false);
    }
    if (isPhantom) {
      let result = await blobToBase64(bufferBlob);

      return new Promise((resolve) => {
        if (result.ret !== 0) {
          resolve({ ret: 1 });
          return;
        }

        let content = result.data.replace(/^data:[a-zA-Z\-\/]+;base64,/, '');

        resolve({ ret: 0, data: { content, isEnd, fileSize, dataSize } });
      });
    }

    return new Promise((resolve) => {
      let content = bufferBlob

      resolve({ ret: 0, data: { content, isEnd, fileSize, dataSize } });
    });
  }
  async getFileBlob({ file }) {
    let fileBlob = null;

    if (this.currentFileBlob) {
      fileBlob = this.currentFileBlob;

      return fileBlob;
    }

    if (file.isCurrentDoc) {
      let fileBuffer = (await this.fileController.getCurrentDocBuffer())[0];

      fileBlob = new Blob(fileBuffer, { type: 'application/pdf' });
      this.currentFileBlob = fileBlob;
    }

    return fileBlob;
  }
  async getCurrentDoc() {
    let doc = await window.pdfui.getCurrentPDFDoc().catch((error) => {
      reject(error);
    });

    if (doc) {
      const { info } = doc;

      return {
        ret: 0,
        data: {
          name: info.fileName,
          isCurrentDoc: true,
          size: info.fileSize,
        },
      };
    }
  }
  cancelUploadShareReview() {
    if (this.uploadShareReviewToken) {
      this.uploadShareReviewToken.cancel()
      this.uploadShareReviewToken = null
    }
  }
  // TODO FOXIT 发起协同——分享评论接口，返回分享链接URL，云编辑替换接口
  uploadShareReview(options) {
    console.log("发起协同——分享评论接口11")
    console.log(options)
    // TODO FOXIT 替换新协同接口
    return this.post({
      url: '/v1/share-review',
      data: qs.stringify({...options}),
      config: {
        params: {
          'access-token': this.token,
        },
      },
    });
  }
  // TODO FOXIT 开启协作—— 获取文件信息
  getShareReview({ cDocID, reviewSessionID, getMore, extDocID }) {
    console.log("getShareReview")
    console.log(store.loginNewStore.isLogin)
    console.log(this.token)
    if(store.loginNewStore.isLogin && !this.token) {
      return
    }
    let url = `/v1/share-review?access-token=${this.token}`;
    if(reviewSessionID) url += `&reviewSessionID=${reviewSessionID}`
    if(cDocID) url += `&cDocID=${cDocID}`
    if(extDocID) url += `&extDocID=${extDocID}`
    if(getMore) url += `&getMore=${getMore}`
    url += `&_=${(new Date()).valueOf()}`
    console.log("没有调用？")
    return this.get({ url });
  }
  putShareReview(data) {
    const url = '/v1/share-review'
    // const url = '/cpdfapi/v1/share-review'
    const config = {
      params: {
        'access-token': this.token,
      }
    }
    return this.put({ url, data, config })
    // return this.put({ url, data: Object.assign(data, {reviewClientID: uuidForCollaboration}), config })
  }

  putShareReviewForTeamsApp(data) {
    const url = '/v1/share-review/ext'
    // const url = '/cpdfapi/v1/share-review/ext'
    const config = {
      params: {
        'access-token': this.token,
      }
    }
    return this.put({ url, data, config })
    // return this.put({ url, data: Object.assign(data, {reviewClientID: uuidForCollaboration}), config })
  }

  // TODO FOXIT 發起協助打開文檔——获取参与者
  getShareReviewParticipant({reviewSessionID, cUserID}) {
    // const url = `/cpdfapi/v1/share-review/participant?reviewSessionID=${reviewSessionID}&cUserID=${cUserID}&access-token=${this.token}&_=${(new Date()).valueOf()}`
    const url = `/v1/share-review/participant?reviewSessionID=${reviewSessionID}&cUserID=${cUserID}&access-token=${this.token}&_=${(new Date()).valueOf()}`
    return this.get({ url })
  }
  postShareReviewParticipant(data) {
    const url = '/v1/share-review/participant'
    // const url = '/cpdfapi/v1/share-review/participant'
    const config = {
      params: {
        'access-token': this.token,
      }
    }
    return this.post({ url, data, config })
  }
  shareReviewParticipant(data) {
    // const url = '/cpdfapi/v1/share-review/participant'
    const url = '/v1/share-review/participant'
    const config = {
      params: {
        'access-token': this.token,
      }
    }
    return this.put({ url, data, config})
  }
  getShareReviewOperandsLog({reviewSessionID,perPage,currentPage}) {
    // const url = `/cpdfapi/v1/share-review/operands-log?access-token=${this.token}&reviewSessionID=${reviewSessionID}&perPage=${perPage}&currentPage=${currentPage}&_=${(new Date()).valueOf()}`
    const url = `/v1/share-review/operands-log?access-token=${this.token}&reviewSessionID=${reviewSessionID}&perPage=${perPage}&currentPage=${currentPage}&_=${(new Date()).valueOf()}`
    return this.get({url})
  }
  putShareReviewBatch(data) {
    // const url = '/cpdfapi/v1/share-review/batch'
    const url = '/v1/share-review/batch'
    const config = {
      params: {
        'access-token': this.token,
      }
    }
    return this.put({ url, data, config})
  }

  uploadFileChunk({ data: { fileName, content, chunk, chunks, reviewSessionID } }, useBase64) {
    if (useBase64) {
      return this.post({
        url: '/v1/server/upload-file',
        // url: '/cpdfapi/v1/server/upload-file',
        data: qs.stringify({
          reviewSessionID,
          fileName,
          content,
          chunk,
          chunks,
        }),
        config: {
          params: {
            'access-token': this.token,
          }
        },
      });
    } else {
      const fd = new FormData()
  
      fd.append('fileName', fileName)
      fd.append('file', content)
      fd.append('chunk', chunk)
      fd.append('chunks', chunks)
      fd.append('reviewSessionID', reviewSessionID)
  
      return this.post({
        url: '/v1/server/upload-file-binary',
        data: fd,
        config: {
          params: {
            'access-token': this.token,
          }
        },
      });
    }
  }
  inviteJoin({cDocID,reviewSessionID,userEmail,fileLink,message,groups}) {
    const { lng } = store.appStore
    const data = qs.stringify({ cDocID, reviewSessionID, userEmail, fileLink, message, groups })
    return this.post({
      url: '/v1/share-review/invite-join',
      // url: '/cpdfapi/v1/share-review/invite-join',
      data,
      config: {
        params: {
          'access-token': this.token,
          'al': lng && lng.full
        },
      },
    })
  }
  openSharedFile({ /*docId,*/ docName, fileLink,error, success }) {
    store.collaborationStore.setFwBeginShare(true)
    return this.fileController.doOpenFileByUrl(fileLink, docName, error, true,success)
  }
  openSharedFileForTeamsApp() {
    const { sharedFileInfo: { sharedDoc, annotsFDFArr, fileName} } = store.collaborationStore
    const arr = toJS(annotsFDFArr)
    
    return pdfui.openPDFByFile(sharedDoc, {fileName, fdf: arr}).then(() => {
      store.appStore.sendPerformanceInfo({ event: APP_CONSTANTS.COLLABORATION_OPEN_FINISH, isEmit: true, lastEvent: true, fileName: true });
      return sharedDoc;
    })
  }
  addAnnotation({ reviewSessionID, annotName, item, pageObjNum, operands, annotType, delFlag }) {
    return this.post({
      url: '/v1/share-review/annotnew',
      data: qs.stringify({
        reviewSessionID,
        annotName,
        item,
        pageObjNum,
        operands,
        annotType,
        delFlag,
      }),
      config: {
        params: {
          'access-token': this.token,
        },
      },
    });
  }
  getShareReviewList({ source, sort, perPage, currentPage, docName }) {
    // const url = `/cpdfapi/v1/share-review/list?source=${source}&sort=${sort}&perPage=${perPage}&currentPage=${currentPage}&docName=${docName}&access-token=${this.token}&_=${(new Date()).valueOf()}`
    const url = `/v1/share-review/list?source=${source}&sort=${sort}&perPage=${perPage}&currentPage=${currentPage}&docName=${docName}&access-token=${this.token}&_=${(new Date()).valueOf()}`
    return this.get({ url })
  }
  getShareRelationship() {
    // const url = `/cpdfapi/v1/users/relationship?access-token=${this.token}&_=${(new Date()).valueOf()}`
    const url = `/v1/users/relationship?access-token=${this.token}&_=${(new Date()).valueOf()}`
    return this.get({ url })
  }
  getShareReviewInviteParticipant(reviewSessionID) {
    const url = `/v1/share-review/invite-participant?access-token=${this.token}&reviewSessionID=${reviewSessionID}&_=${(new Date()).valueOf()}`
    // const url = `/cpdfapi/v1/share-review/invite-participant?access-token=${this.token}&reviewSessionID=${reviewSessionID}&_=${(new Date()).valueOf()}`
    return this.get({ url })
  }
  putShareReviewInviteParticipantBatch(data) {
    const url = '/v1/share-review/participant/batch'
    const config = {
      params: {
        'access-token': this.token,
      }
    }
    return this.put({ url, data, config})
  }
  getAnnotFromS3({item}) {
    const url = '/v1/share-review/annotnew';
    const config = {
      params: {
        'access-token': this.token,
        item,
      },
    };

    return this.get({
      url,
      config,
    });
  }

  annotationAction({ actionType, reviewSessionID, annotName, item, pageObjNum, operands, annotType, delFlag, pushAnnotAxiosTask }) {
    let method;
    const cancelSource = this.getCancelSource();
    const { uuidForCollaboration } = store.collaborationStore;

    switch (actionType) {
      case 'add':
        method = this.post;
        break;
      case 'update':
      case 'delete':
        method = this.put;
        break;
      default:
        break;
    }

    pushAnnotAxiosTask({cancelSource, annotName})
    return method({
      url: '/v1/share-review/annotnew',
      data: qs.stringify({
        reviewSessionID,
        annotName,
        item,
        pageObjNum,
        operands,
        annotType,
        delFlag,
        reviewClientID: uuidForCollaboration,
      }),
      config: {
        params: {
          'access-token': this.token,
        },
        cancelToken: cancelSource.token,
      },
    });
  }
  // 获取全部的注释信息
  getAnnotListAll({reviewSessionID, lastTime, pageObjNum, annotType}) {
    // TODO FOXIT 替换云编辑接口 v1/share-review/listnew?reviewSessionID
    return this.get({
      url: '/v1/share-review/listnew',
      // url: '/cpdfapi/v1/share-review/listnew',
      config: {
        params: {
          'access-token': this.token,
          reviewSessionID,
          lastTime,
          pageObjNum,
          annotType,
          getYourself: 1
        }
      }
    })
  }
  async getNotificationPollingConfig() {
    const config = {
      url: '/v1/messages/polling/config',
      // url: '/cpdfapi/v1/messages/polling/config',
      config: {
        params: {
          'access-token': verifyAndGetToken(store.userStore.token),
          appType: 1,
          dt: (new Date()).valueOf(),
        }
      }
    }

    const data = verifyAndGetData(await this.get(config), config)

    return {
      minimumPollingTime: verifyAndGetValue(data, '0.minimumPollingTime'),
      maxPollingNotResultCount: verifyAndGetValue(data, '0.maxPollingNotResultCount'),
    }
  }

  async getNotificationStatistic() {
    const config = {
      // url: '/cpdfapi/v1/messages/polling',
      url: '/v1/messages/polling',
      data: {
        parameterList: [{
          token: verifyAndGetToken(store.userStore.token),
          type: 110,
        }]
      }
    }

    const data = verifyAndGetData(await this.post(config), config)

    return {
      nextPollingTime: verifyAndGetValue(data, '0.nextPollingTime'),
      untreatedNotify: verifyAndGetValue(data, '1.data.untreatedNotify', 0),
    }
  }

  getNotificationIFrameSrc({ al }) {
    const url = createURLString(
      this.CPDFURI,
      ['/message/notification'],
      {
        'access-token': verifyAndGetToken(store.userStore.token),
        al,
        cv: NOTIFICATION_PARAMS.cv,
        an: NOTIFICATION_PARAMS.an,
        av: NOTIFICATION_PARAMS.av,
      }
    )
    return url
  }
  postErrorMsg({type,errorInfo}){
    store.collaborationStore.messageError({type,errorInfo})
  }
  getDocReviewRessionId(docId) {
    const url = `/v1/share-review/review-session-id?docId=${docId}`
    return this.get({ url })
  }
  sendMentionMsg(options) {
    const { lng } = store.appStore;
    // options.emailList = JSON.stringify(options.emailList);
    return this.post({
      url: '/v1/share-review/mention',
      data: qs.stringify({
        ...options
      }),
      config: {
        params: {
          'access-token': this.token,
          'al': lng && lng.full
        },
      },
    });
  }
  getShareReviewQueueUrl(reviewSessionID) {
    return this.post({
      url: '/v1/share-review/queue',
      data: qs.stringify({
        reviewSessionID
      })
    })
  }
  unShare (reviewSessionID, password) {
    return this.delete({
      url: '/v1/share-review',
      config: {
        params: {
          'access-token': this.token,
        },
        data: {
          reviewSessionID, 
          isSaveDoc: 1,
          isStorage: 0,
          password
        }
      },
    })
  }
  sendCollabOp(reviewSessionID,data){
    const cancelSource = this.getCancelSource();
    this.post({
      url: '/v1/share-review/sync-operate',
      data: qs.stringify({
        reviewSessionID,
        operate:JSON.stringify(data)
      }),
      config: {
        params: {
          'access-token': this.token,
        },
        cancelToken: cancelSource.token,
      },
    });
  }
}


